module.exports = __webpack_public_path__ + "static/img/jl-hop.6b0ceae.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/case/jl-hop.jpg
// module id = 2TCe
// module chunks = 1